if ($('#datepicker').length) {
	$datepicker = $('#datepicker');

	$datepicker.datepicker({
		format: "yyyy/mm",
		minViewMode: 1
	});
}

exports.modules = 'datepicker';